module.exports = __webpack_public_path__ + "img/procedural-terrain2.89a6bd74.png";